// Chat and the social windows' data.
import { ChatChannel } from '../../../shared/src/constants';
import { WordFilter } from '../../../shared/src/rules/names';
import { game } from './game';

let profanity = new WordFilter([]);

/** The chat profanity list (Content/profanity.txt), used while the page's profanity setting is on. */
export function useProfanityList(text: string): void { profanity = WordFilter.parse(text); }

export function channelColor(c: ChatChannel): string {
  switch (c) {
    case ChatChannel.System: return '#fad678';
    case ChatChannel.Party: return '#78d2f0';
    case ChatChannel.Whisper: return '#ec8cdc';
    case ChatChannel.Error: return '#f06058';
    case ChatChannel.Global: return '#f0c8aa';
    case ChatChannel.Map: return '#a0e196';
    default: return '#ece2d6';
  }
}

/** The chat log: each line's lead-in split so the sender's name can be clicked. */
export function chat(filter: boolean): object[] {
  const s = game.session;
  if (!s) return [];
  return s.chat.map(line => {
    let label = '', name = line.from, after = ': ';
    if (!line.from) {
      label = line.channel === ChatChannel.Party ? '[Party] ' : line.channel === ChatChannel.Map ? '[Map] ' : '';
      name = after = '';
    } else if (line.channel === ChatChannel.Party) label = '[Party] ';
    else if (line.channel === ChatChannel.Global) label = '[Global] ';
    else if (line.channel === ChatChannel.Map) label = '[Map] ';
    else if (line.channel === ChatChannel.Whisper && line.from.startsWith('to ')) { label = '[to '; name = line.from.slice(3); after = '] '; }
    else if (line.channel === ChatChannel.Whisper) { label = '['; after = '] '; }
    const player = line.channel !== ChatChannel.System && line.channel !== ChatChannel.Error;
    return {
      t: line.time, color: channelColor(line.channel), label, name: player ? name : '', after: player ? after : name + after,
      text: filter && player ? profanity.mask(line.text) : line.text,
      // Spoken aloud to those about (a bubble over the speaker while they are in view).
      spoken: player && (line.channel === ChatChannel.Say || line.channel === ChatChannel.Party || line.channel === ChatChannel.Map) ? line.from : '',
    };
  });
}

/** Everyone online (Tab), the ignore and friend lists and the party. */
export function social(): object {
  const s = game.session;
  if (!s) return {};
  return {
    server: s.serverName, max: s.maxPlayers, me: s.local.name, ping: s.ping, online: Math.max(1, s.players.length),
    zone: s.world.zoneName,
    players: s.players.map(p => ({ name: p.name, zone: p.zoneName, appearance: p.appearance, party: p.inMyParty, here: p.sameMap })),
    ignored: s.ignored, friends: s.friends.map(f => ({ name: f.name, online: f.online, zone: f.zoneName, level: f.level })), leader: s.partyLeader, partyMax: s.partyMaxSize, isLeader: s.isPartyLeader,
    party: s.partyMembers.map(m => ({ name: m.name, appearance: m.appearance, hp: m.healthPct, zone: m.zoneName, online: m.online, id: m.entityId })),
    invite: s.pendingInvite && s.pendingInvite.expires > s.time ? { from: s.pendingInvite.from, left: s.pendingInvite.expires - s.time } : undefined,
    tradeInvite: s.pendingTrade && s.pendingTrade.expires > s.time ? { from: s.pendingTrade.from, left: s.pendingTrade.expires - s.time } : undefined,
  };
}
